export default __webpack_public_path__ + "static/media/privacy-policy.b3d941f1.md";